import { Box, Tab, Tabs, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  dashboardProfit,
  deletePayment,
  deletePurchaseOrder,
  deleteOrder,
} from "../../utils/api";
import { formatDate } from "../../utils/formatData";
import DeleteModal from "../modals/DeleteModal";
import Table from "../Table";
import EditPayment from "./EditPayment";
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ProfitAndPurchase = ({ dashboardCount, dash, customers }) => {
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [payments, setPayments] = useState({});
  const [loading, setLoading] = useState(false);
  const getAllPaymentsHandler = async () => {
    setLoading(true);
    const [success, data] = await dashboardProfit();
    if (success) {
      setPayments(data);
    }
    setLoading(false);
  };

  useEffect(() => {
    getAllPaymentsHandler();
  }, []);
  return (
    <>
      {dashboardCount?.dataType === "Profit" && (
        <Box sx={{ width: "100%", marginTop: "20px" }}>
          <div className="flex gap-6">
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab
                  label={`Payment (${payments?.paymentAmount})`}
                  {...a11yProps(0)}
                />

                <Tab
                  label={`Received (${payments?.receivedAmount})`}
                  {...a11yProps(1)}
                />
              </Tabs>
            </Box>
            <div className="z-[30]  rounded-full  flex items-center justify-center">
              Balance (Without GST) :{payments?.balanceWithoutGst?.toFixed(2)}
            </div>
            <div className="z-[30]  rounded-full  flex items-center justify-center">
              Balance (With GST) :{payments?.balanceWithGst?.toFixed(2)}
            </div>
            <div className="z-[30]  rounded-full  flex items-center justify-center">
              Due Payment :{payments?.duePayment?.toFixed(2)}
            </div>
            <div className="z-[30]  rounded-full  flex items-center justify-center">
              Adjustment :{payments?.adjustment?.toFixed(2)}
            </div>
          </div>
          <CustomTabPanel value={value} index={0}>
            <Table
              data={
                payments?.payments?.length > 0
                  ? [...payments?.payments]?.reverse()
                  : []
              }
              columns={[
                {
                  title: "Date",
                  dataIndex: "date",
                  render: (record) => formatDate(record?.date),
                },
                {
                  title: "Customer Name",
                  render: (record) => record?.customer?.userName,
                },
                {
                  title: "description",
                  dataIndex: "description",
                },
                {
                  title: "Payment Type",
                  dataIndex: "paymentType",
                },
                {
                  title: "Amount",
                  dataIndex: "amount",
                  render: (record) => `₹ ${record.amount?.toFixed(2)}`,
                },
                {
                  title: "User",
                  dataIndex: "completedByName",
                },

                {
                  title: "Actions",
                  render: (record) => (
                    <div className="flex items-center gap-2">
                      <EditPayment
                        data={record}
                        reload={getAllPaymentsHandler}
                        customers={customers || []}
                      />
                      <DeleteModal
                        loading={loading}
                        onClick={async () => {
                          setLoading(true);
                          const [success, data] = await deletePayment(record._id);
                          if (success) {
                            toast.success("Payment Deleted");
                            getAllPaymentsHandler();
                          } else {
                            toast.error(data || "Payment Not Deleted");
                          }
                          setLoading(false);
                        }}
                      >
                        Delete
                      </DeleteModal>
                    </div>
                  ),
                },
                {
                  title: "PDF",
                  link: "/admin/pdf/profit",
                },
              ]}
            />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <Table
              data={
                payments?.received?.length > 0
                  ? [...payments?.received]?.reverse()
                  : []
              }
              columns={[
                {
                  title: "Date",
                  dataIndex: "date",
                  render: (record) => formatDate(record?.date),
                },
                {
                  title: "Customer Name",
                  render: (record) =>
                    record?.type === "PurchaseOrder"
                      ? record?.clients?.userName
                      : record?.customer?.userName,
                },
                {
                  title: "description",
                  dataIndex: "description",
                },
                {
                  title: "Payment Type",
                  dataIndex: "type",
                  render: (record) =>
                    record.type === "PurchaseOrder"
                      ? "PurchaseOrder"
                      : record.paymentType,
                },

                {
                  title: "Amount",
                  dataIndex: "amount",
                  render: (record) =>
                    `₹ ${
                      record.amount?.toFixed(2) ??
                      record?.totalAmount?.toFixed(2)
                    }`,
                },
                { title: "User", dataIndex: "completedByName" },
                {
                  title: "Actions",
                  render: (record) => (
                    <div className="flex items-center gap-2">
                      <EditPayment
                        data={record}
                        reload={getAllPaymentsHandler}
                        customers={customers || []}
                      />
                      <DeleteModal
                        loading={loading}
                        onClick={async () => {
                          setLoading(true);
                          if (record?.type === "PurchaseOrder") {
                            const [success, data] = await deletePurchaseOrder(
                              record._id
                            );
                            if (success) {
                              toast.success("Purchase Order Deleted");
                              getAllPaymentsHandler();
                            } else {
                              toast.error(data || "Purchase Order Not Deleted");
                            }
                          } else if (record?.paymentType) {
                            const [success, data] = await deletePayment(
                              record._id
                            );
                            if (success) {
                              toast.success("Payment Deleted");
                              getAllPaymentsHandler();
                            } else {
                              toast.error(data || "Payment Not Deleted");
                            }
                          } else {
                            const [success, data] = await deleteOrder(
                              record._id
                            );
                            if (success) {
                              toast.success("Order Deleted");
                              getAllPaymentsHandler();
                            } else {
                              toast.error(data || "Order Not Deleted");
                            }
                          }
                          setLoading(false);
                        }}
                      >
                        Delete
                      </DeleteModal>
                    </div>
                  ),
                },
                {
                  title: "PDF",
                  link: "/admin/pdf/received",
                },
              ]}
            />
          </CustomTabPanel>
        </Box>
      )}
    </>
  );
};

export default ProfitAndPurchase;

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}
